<script>
import { OwalLabelStyle } from './OwalLabelStyle'

/**
 *
 */
export default {
  name: 'OwalLabel',
  props: {
    type: {
      type: Number,
      default: 0,
    },
    accessoryCallback: {
      type: Function,
      default: undefined,
    },
    color: {
      type: String,
      default: '#4A4A4A',
    },
    secondaryColor: {
      type: String,
      default: '#ffffff',
    },
  },
  computed: {
    cssForStyle () {
      if (this.type === OwalLabelStyle.BASIC || this.type === OwalLabelStyle.TAG) {
        return `color: ${this.secondaryColor}; background-color: ${this.color};`
      } else if (this.type === OwalLabelStyle.OUTLINE) {
        return `color: ${this.color}; background-color: ${this.secondaryColor}; border-color: ${this.color}`
      }
      return ``
    },
    className () {
      const type = this.type
      const suffix = OwalLabelStyle.properties[type].description
      return `owal-label__container_${suffix}`
    },
  },
}
</script>

<template>
  <div
    :class="this.className"
    :style="this.cssForStyle"
  >
    <slot />
    <slot
      v-if="type === 2"
      name="accessory"
    >
      <div
        class="owal-label__right-accessory"
        @click="accessoryCallback"
      >
        x
      </div>
    </slot>
  </div>
</template>

<style scoped>
.owal-label__container_basic,
.owal-label__container_outline,
.owal-label__container_tag {
  border-radius: 0.35rem;
  padding: 0.35rem;
  margin: 0.2rem 0.35rem;
  display: flex;
  flex-grow: 0;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: fit-content;
}

.owal-label__container_outline
{
  border: 1px solid;
}

.owal-label__right-accessory {
  margin: 0 0 0 0.35rem;
  font-weight: bold;
  padding: 0 0.25rem;
  border-radius: 0.35rem;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 150ms linear;
  user-select: none;
}

.owal-label__right-accessory:hover {
  background-color: rgba(255, 255, 255, 0.25);
}

</style>
